import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { pedirJson } from "../../nucleo/api";
import { Aviso, Botao, Campo } from "../ui";

const esquema = z.object({
  configurado: z.boolean(),
  opcoes: z.array(z.object({ valor: z.string(), rotulo: z.string() })),
});

/**
 * O segmento da organização. Com o GeoTask configurado, é uma escolha do catálogo SEGMENT; sem
 * ele (`configurado` falso), ou com o catálogo fora de alcance (rede, 403), é o texto livre de
 * sempre — o cadastro não depende do GeoTask.
 */
export function SelecaoDeSegmento({
  value, onChange, disabled = false, placeholder,
}: {
  value: string;
  onChange: (valor: string) => void;
  disabled?: boolean;
  /** Exemplo do texto livre, quando não há catálogo. */
  placeholder?: string;
}) {
  const consulta = useQuery({
    queryKey: ["geotask", "segmentos"],
    queryFn: ({ signal }) => pedirJson("/implantacoes/catalogo/segmentos", esquema, { signal }),
    staleTime: 5 * 60_000,
  });
  /* Enquanto o catálogo não confirma que existe, ou se ele falhar, vale o texto livre: digitar
     não espera rede, e uma falha do GeoTask não tira o campo de quem cadastra. */
  if (consulta.isError || !consulta.data?.configurado) {
    return (
      <div>
        <Campo
          rotulo="Segmento"
          value={value}
          disabled={disabled}
          onChange={(evento) => onChange(evento.target.value)}
          placeholder={placeholder}
        />
        {consulta.isError ? (
          <Aviso tom="atencao">
            A lista de segmentos do GeoTask não carregou; o segmento segue como texto livre.{" "}
            <Botao variante="fantasma" tamanho="pequeno" onClick={() => void consulta.refetch()}>
              Tentar de novo
            </Botao>
          </Aviso>
        ) : null}
      </div>
    );
  }
  const opcoes = consulta.data?.opcoes ?? [];
  const legado = value && !opcoes.some((item) => item.valor === value);
  return (
    <div className="campo">
      <label className="campo__rotulo" htmlFor="segmento-do-geotask">Segmento</label>
      <select
        id="segmento-do-geotask"
        className="campo__controle"
        value={value}
        disabled={disabled}
        onChange={(evento) => onChange(evento.target.value)}
      >
        <option value="">Sem segmento</option>
        {legado ? <option value={value}>{value} (fora do catálogo)</option> : null}
        {opcoes.map((item) => <option key={item.valor} value={item.valor}>{item.rotulo}</option>)}
      </select>
      {legado ? (
        <Aviso tom="atencao">Esse segmento não existe no GeoTask. Escolha uma opção do catálogo ao corrigir o cadastro.</Aviso>
      ) : null}
    </div>
  );
}
